import React, { Component } from 'react'
import { Row, Card, Col, } from 'reactstrap'
import { ManageUsersCard, ManageUsersSidebar, } from './'

class NewManageUsers extends Component {
  render() {
    return (
      <Card className='manage-users-container'>
        <Row noGutters>
          <Col className='manage-users-sidebar' xs='12' lg='2'>
            <ManageUsersSidebar {...this.props} />
          </Col>
          <Col className='manage-users-content' xs='12' lg='10'>
            <ManageUsersCard {...this.props} />
          </Col>
        </Row>
      </Card>
    )
  }
}

export default NewManageUsers


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/NewManageUsers.js